// extracted by mini-css-extract-plugin
export default {"animated_background":"bulkQr_animated_background__xVDS3"};